export const GET_PROVINCE_URL         = 'province/list'
export const GET_PROVINCE_ERROR       = 'GET_PROVINCE_ERROR'
export const GET_PROVINCE_LOADING     = 'GET_PROVINCE_LOADING'
export const GET_PROVINCE_SUCCESS     = 'GET_PROVINCE_SUCCESS'

export const GET_CITY_URL         = 'city/list'
export const GET_CITY_ERROR       = 'GET_CITY_ERROR'
export const GET_CITY_LOADING     = 'GET_CITY_LOADING'
export const GET_CITY_SUCCESS     = 'GET_CITY_SUCCESS'
